import React from 'react';
import { RotateCcw } from 'lucide-react';

/**
 * LandscapeWarning
 *
 * Renders a full-screen overlay when the device is held in landscape
 * orientation with a height <= 500px (i.e. a phone, not a desktop monitor).
 *
 * Visibility is controlled entirely by CSS (.landscape-warning in index.css)
 * so no JS orientation listeners are needed -- the overlay simply exists in
 * the DOM at all times and is shown/hidden via media query.
 *
 * This is the iOS fallback: the Web App Manifest "orientation": "portrait"
 * handles Android PWAs, but Apple ignores that field for Add-to-Home-Screen apps.
 */
const LandscapeWarning = () => {
  return (
    <div
      className="landscape-warning fixed inset-0 z-[9999] bg-gray-900/95 flex-col items-center justify-center gap-6 px-8 text-center"
      aria-live="assertive"
      role="alert"
    >
      <div className="flex items-center justify-center w-20 h-20 rounded-full bg-blue-800/20 border border-blue-700/40">
        <RotateCcw className="w-10 h-10 text-blue-400 animate-spin" style={{ animationDuration: '3s' }} />
      </div>
      <div className="space-y-2">
        <p className="text-white text-xl font-semibold">Rotate your device</p>
        <p className="text-gray-400 text-sm leading-relaxed">
          This app is designed for portrait mode.<br />
          Please rotate your phone upright to continue.
        </p>
      </div>
    </div>
  );
};

export default LandscapeWarning;
